import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportProfile } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (exportProfileId: number) => {
  if (!exportProfileId) {
    throw new Error('`exportProfileId` is required');
  }
};

type RequestParams = {
  exportProfileId: number;
};

type Response = DBExportProfile;

export const getExportProfileById = async (
  scope: RequestScope,
  { exportProfileId }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(exportProfileId);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`export_profile/${exportProfileId}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
